import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiAssessmentResult, AssessmentDimension } from '../../services/ai-assessment.service';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-ai-result-drawer',
  templateUrl: './ai-result-drawer.component.html',
  styleUrls: ['./ai-result-drawer.component.scss'],
  imports: [CommonModule, MaterialModule]
})
export class AiResultDrawerComponent {
  @Input() resultJson: string | null = null;
  @Input() appName: string = '';
  @Output() closeDrawer = new EventEmitter<void>();

  parsedResult: AiAssessmentResult | null = null;
  parseError: string | null = null;
  rawJsonView: boolean = false;

  ngOnChanges(): void {
    this.parseResult();
  }

  private parseResult(): void {
    if (!this.resultJson) {
      this.parsedResult = null;
      this.parseError = null;
      return;
    }

    try {
      this.parsedResult = JSON.parse(this.resultJson);
      this.parseError = null;
    } catch (error) {
      this.parseError = 'Failed to parse assessment result JSON';
      this.parsedResult = null;
      console.error('JSON parse error:', error);
    }
  }

  close(): void {
    this.closeDrawer.emit();
  }

  toggleRawJson(): void {
    this.rawJsonView = !this.rawJsonView;
  }

  copyToClipboard(): void {
    if (this.resultJson) {
      navigator.clipboard.writeText(this.resultJson);
    }
  }

  getScoreClass(score: number): string {
    if (score >= 70) return 'score-high';
    if (score >= 40) return 'score-medium';
    return 'score-low';
  }

  getSizeClass(size: string): string {
    const normalized = size.toLowerCase();
    if (normalized === 'small') return 'size-small';
    if (normalized === 'medium') return 'size-medium';
    if (normalized === 'large') return 'size-large';
    return 'size-unknown';
  }

  getDimensionArray(): { key: string; value: AssessmentDimension }[] {
    if (!this.parsedResult?.dimensions) return [];
    
    return Object.entries(this.parsedResult.dimensions).map(([key, value]) => ({
      key: this.formatDimensionKey(key),
      value
    }));
  }

  private formatDimensionKey(key: string): string {
    // Convert camelCase to Title Case with spaces
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }
}
